export const DEFAULT_LOCALE = 'en'
export const FB_2FA_NOT_SETUP_GRACE_PERIOD_EXCEEDED = 'FB_2FA_NOT_SETUP_GRACE_PERIOD_EXCEEDED'
export const ACCESS_TOKEN_ERR_MESSAGE = 'Access token is invalid'
